import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import '../Styles/global.scss';
import '../Styles/style.scss';
import {SearchBlockProvider} from './ManageBlock/ManageBlock';
import {CreateBlockProvider} from './CreateBlock/CreateBlock';
import {SearchQuestionProvider} from './ManageQuestion/ManageQuestion';
import {CreateQuestionProvider} from './CreateQuestion/CreateQuestion';
import {SearchListProvider} from './ManageList/ManageList';
import {CreateListProvider} from './CreateList/CreateList';
import {ManageControlPlannedProvider} from './ManageControlPlanned/ManageControlPlanned';
import {ManageControlActiveProvider} from './ManageControlActive/ManageControlActive';
import {ManageControlDoneProvider} from './ManageControlDone/ManageControlDone';
import {MyControlPlannedProvider} from './MyControlPlanned/MyControlPlanned';
import {MyControlActiveProvider} from './MyControlActive/MyControlActive';
import {MyControlDoneProvider} from './MyControlDone/MyControlDone';
import {ControlListProvider} from './ControlList/ControlList';
import {ControlListInControlDetailProvider} from './ControlListInControlDetail/ControlListInControlDetail';
import {CreateControlProvider} from './CreateControl/CreateControl';
import {UpdateControlProvider} from './CreateControl/UpdateControl';
import {ControlDetailProvider} from './ControlDetail/ControlDetail';
import {ExternalControlDetailProvider} from './ExternalControlDetail/ExternalControlDetail';
import {ManagePostControlInfoProvider} from './ManagePostControlInfo/ManagePostControlInfo';
import {CreatePostControlInfoProvider} from './CreatePostControlInfo/CreatePostControlInfo';
import {CreatePostControlNoteProvider} from './CreatePostControlNote/CreatePostControlNote';
import {ControlListDetailProvider} from './ControlListDetail/ControlListDetail';
import {PostControlInfoDetailProvider} from './PostControlInfoDetail/PostControlInfoDetail';
import {PostControlNoteDetailProvider} from './PostControlNoteDetail/PostControlNoteDetail';
import {ExternalControlsProvider} from './ExternalControls/ExternalControls';
import {ExternalControlContainer} from './ExternalControl/ExternalControlContainer';
import ScrollToTop from '../Helpers/ScrollToTop'
import {Home} from './Home/Home';
import {Help} from './Help/Help';
import {SkipLinks} from './SkipLinks/SkipLinks';
import Login from './Login/Login';
import Frame from './Frame/Frame';
import {BrowserRouter as Router, Redirect, Route} from 'react-router-dom';
import {Switch} from 'react-router';
import {connect} from 'react-redux';
import {getUserData} from '../Redux/Actions/userData';
import {getRemainingTokenTimeInSecForRefreshToken, isUserLoggedIn, isTokenExpired} from '../Helpers/utils';
import {LoginInfoProvider} from './LoginInfo/LoginInfo';
import {getProgramsData, setSelectedProgsData} from '../Redux/Actions/Programs';
import {PopUpWithRedirect} from "./PopupWithRedirect/PopupWithRedirect";
import {handleLogOut} from '../Helpers/SessionTimer';

class App extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isMenuFocused: false,
			userTime: localStorage.getItem("userTime")
		};
		this.contentRef = React.createRef();
		this.loginInfoRef = React.createRef();
	}

	setContentFocused = () => {
		const mainContent = this.contentRef.current;
		if (mainContent) {
			mainContent.setAttribute('tabIndex', -1);
			mainContent.focus();
			window.scrollTo(0, 0);
		}
	};

	getUser = () => {
		if (this.props.userData.isLogged === false &&
			this.props.userData.isLoading === false &&
			isUserLoggedIn()) {
			this.props.getUserData();
		}
	};

	managePrograms = () => {
		this.props.setPrograms();
		const selectedProgram = localStorage.getItem("selectedProgram") && localStorage.getItem("selectedProgram") !== 'undefined' ? JSON.parse(localStorage.getItem("selectedProgram")) : null;
		const programDescriptors = localStorage.getItem("programDescriptors");
		const isSelectedProgramInPrograms = Boolean(programDescriptors?.includes(selectedProgram?.code));
		if (selectedProgram && isSelectedProgramInPrograms) {
			this.props.setSelectedProgram(selectedProgram);
		} else {
			this.props.setSelectedProgram(null);
		}
	};

	async componentDidMount() {
		this.getUser();
		this.managePrograms();
	}

	refreshToken() {
		const time = localStorage.getItem("userTime");
		if (time !== this.state.userTime && getRemainingTokenTimeInSecForRefreshToken(time) < 1790) {
			this.setState({
				userTime: localStorage.getItem("userTime"),
			})
		}
	}

	componentDidUpdate() {
		this.getUser();
	}


	handleCloseUserMenuApp = () => {
		const mainContent = this.loginInfoRef.current;
		if(mainContent) {
			this.loginInfoRef.current.handleCloseUserMenu()
		}
	}
	setMenuFocused = () => this.setState({ isMenuFocused: true });

	render() {

		if(isTokenExpired()) {
			handleLogOut();
			return;
		}

		this.refreshToken();
		const userRole = this.props.userData.user?.roleDetails?.role;
		const userLogged = this.props.userData.isLogged;

		return (
			<>
				<div id='page' onClick={this.handleCloseUserMenuApp} >
					{userLogged === true ?
						(<Router>
							<LoginInfoProvider key={this.state.userTime} ref={this.loginInfoRef}/>
							<SkipLinks
								onClickFocusContent={this.setContentFocused}
								onClickFocusMenu={this.setMenuFocused}
							/>
							<ScrollToTop>
							<Frame
								is_logged={userLogged}
								isMenuFocused={this.state.isMenuFocused}
							/>
							<main className='main-container' id='main-container' ref={this.contentRef}>
							<Switch>
								{userRole === 'SA' && [
									<Route key="/search_block" path='/search_block' component={SearchBlockProvider} />,
									<Route key="/create_block" path='/create_block' component={CreateBlockProvider} />,
								]}

								{(userRole === 'A' || userRole === 'SA') && [
									<Route key="/search_question" path='/search_question' component={SearchQuestionProvider} />,
									<Route key="/create_question" path='/create_question' component={CreateQuestionProvider} />,
									<Route key="/manage_lists/edit_list" path='/manage_lists/edit_list/:listId' component={CreateListProvider} />,
									<Route key="/manage_lists/copy_list" path='/manage_lists/copy_list/:parentListId' component={CreateListProvider} />,
									<Route key="/create_list" path='/create_list' component={CreateListProvider} />,
								]}

								{(userRole === 'SK' || userRole === 'A' || userRole === 'SA') && [
										<Route key="/manage_lists/exact" exact path='/manage_lists/:pageNumber?' component={SearchListProvider}/>,
										<Route key="/manage_lists/list_detail" path='/manage_lists/list_detail/:listId' component={ControlListDetailProvider}/>,
										<Route key="/create_control" path='/create_control' component={CreateControlProvider}/>,
										<Route key="/controls/edit_control" path='/controls/edit_control/:controlId/source/:source' component={UpdateControlProvider}/>,
										<Route key="/controls/planned" path='/controls/planned/:pageNumber?' component={ManageControlPlannedProvider}/>,
										<Route key="/controls/active" path='/controls/active/:pageNumber?' component={ManageControlActiveProvider}/>,
										<Route key="/controls/done" path='/controls/done/:pageNumber?' component={ManageControlDoneProvider}/>,
										<Route key="/controls/control_detail" path='/controls/control_detail/:controlId' component={ControlDetailProvider}/>,
										<Route key="/controls/list_detail" path='/controls/list_detail/:listId' component={ControlListDetailProvider}/>,
										<Route key="/controls/control_list_detail" path='/controls/control_list_detail/:controlId'
											component={ControlListInControlDetailProvider}/>,
										<Route key="/controls/post_control_info_detail" path='/controls/:controlId/post_control_info_detail/:infoId' component={PostControlInfoDetailProvider}/>,
										<Route key="/controls/post_control_note_detail" path='/controls/:controlId/post_control_note_detail/:noteId' component={PostControlNoteDetailProvider}/>

								]}

								{(userRole === 'O' ||userRole === 'K' || userRole === 'SK' || userRole === 'A' || userRole === 'SA') && [
											<Route key="/my_controls/planned" path='/my_controls/planned/:pageNumber?' component={MyControlPlannedProvider}/>,
											<Route key="/my_controls/active" path='/my_controls/active/:pageNumber?' component={MyControlActiveProvider}/>,
											<Route key="/my_controls/done" path='/my_controls/done/:pageNumber?' component={MyControlDoneProvider}/>,
											<Route key="/my_controls/control_list" path='/my_controls/control_list/:controlId' component={ControlListProvider}/>,
											<Route key="/my_controls/post_control_info" path='/my_controls/:controlId/post_control_info/:infoId' component={CreatePostControlInfoProvider}/>,
											<Route key="/my_controls/post_control_note" path='/my_controls/:controlId/post_control_note/:noteId' component={CreatePostControlNoteProvider}/>,
											<Route key="/my_controls/post_control_info_detail_render" path='/my_controls/:controlId/post_control_info_detail/:infoId' render={(props) => (<PostControlInfoDetailProvider {...props} source="my_controls" /> )}/>,
											<Route key="/my_controls/post_control_note_detail_render" path='/my_controls/:controlId/post_control_note_detail/:noteId' render={(props) => (<PostControlNoteDetailProvider {...props} source="my_controls" /> )}/>,
											<Route key="/my_controls/control_detail_render" path='/my_controls/control_detail/:controlId' render={(props) => (<ControlDetailProvider {...props} source="my_controls" /> )}/>,
											<Route key="/my_controls/control_list_detail_render" path='/my_controls/control_list_detail/:controlId' render={(props) => (<ControlListInControlDetailProvider {...props} source="my_controls" /> )}/>,
											<Route key="/my_controls/list_detail" path='/my_controls/list_detail/:listId' component={ControlListDetailProvider}/>,
											<Route key="/external_control/create" path='/external_control/create' component={ExternalControlContainer}/>,
											<Route key="/external_controls/type" path='/external_controls/:type/:controlId' component={ExternalControlContainer}/>
								]}

								{(userRole === 'O' || userRole === 'K' || userRole === 'SK' || userRole === 'A' || userRole === 'SA') && [
										<Route key="/post_control/exact" exact path='/post_control/:pageNumber?' component={ManagePostControlInfoProvider}/>,
										<Route key="/post_control/info_detail" path='/post_control/:controlId/post_control_info_detail/:infoId'
										    component={PostControlInfoDetailProvider}/>,
										<Route key="/post_control/note_detail" path='/post_control/:controlId/post_control_note_detail/:noteId'
										    component={PostControlNoteDetailProvider}/>,
										<Route key="/post_control/control_detail" path='/post_control/control_detail/:controlId' component={ControlDetailProvider}/>,
										<Route key="/post_control/control_list_detail_general" path='/post_control/control_list_detail/:controlId'
										    component={ControlListInControlDetailProvider}/>,
										<Route key="/external_controls_list" path='/external_controls_list/:pageNumber?' component={ExternalControlsProvider}/>,
										<Route key="/external_control/external_control_detail" path='/external_control/external_control_detail/:controlId' component={ExternalControlDetailProvider}/>
								]}
							<Route key="/help" exact path='/help' component={Help}/>
							<Route key="/" exact path='/' component={Home}/>
							<Route key="/login_redirect" path='/login' component={() => {
								return <Redirect to='/'/>
							}} />
							<Route key="popup-redirect" component={PopUpWithRedirect} />
						</Switch>
						</main>
					</ScrollToTop>
					</Router>) : (
					<Router>
						<ScrollToTop>
							<Frame is_logged={userLogged}/>
								<div className='main-container'>
									<Route exact path='/login' component={Login} />
									<Route path="*">
										<Login />
									</Route>
								</div>
						</ScrollToTop>
					</Router>
					)}
				</div>
			</>
		)
	}
}


const mapStateToProps = (state) => {
	return state;
};

const mapDispatchToProps = (dispatch) => {
	return {
		getUserData: () => dispatch(getUserData()),
		setPrograms: () => dispatch(getProgramsData()),
		setSelectedProgram: (program) => dispatch(setSelectedProgsData(program)),
	}
};
export const AppProvider = connect(mapStateToProps, mapDispatchToProps)(App);

